import axios from "axios";
import { getURL } from "../constants/index";
import store from "../redux/store";
import { puntToSignIn } from "./APIService";

export async function getService(country) {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null)
    puntToSignIn();
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "GET",
      url: WebAPI_URL + "api/state/get/" + country,
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
}
